module.exports = __webpack_public_path__ + "static/media/sitemap.a2f8924d.png";